import { ComponentChild, FunctionComponent, JSX, createElement } from "preact";

// https://stackoverflow.com/questions/58200824/generic-react-typescript-component-with-as-prop-able-to-render-any-valid-dom
// https://react-typescript-cheatsheet.netlify.app/docs/advanced/patterns_by_usecase/#polymorphic-components-eg-with-as-props
export type CellProps = (
  | ({ tag: 'td' } & JSX.IntrinsicElements['td'])
  | ({ tag: 'th' } & JSX.IntrinsicElements['th'])
)

// TODO: Not sure if this is useful

export type CellsProps = CellProps & { cells: ComponentChild[] }
const TableCells: FunctionComponent<CellsProps> = ({ cells, tag, ...rest }) => {
 return <>{ cells.map(c => createElement(tag, rest, c)) }</>;
};

export type RowProps = CellsProps & { rowClass?: string }
export const TableRow: FunctionComponent<RowProps> = ({ rowClass, ...props }) => {
  return <tr class={ rowClass ?? '' }><TableCells { ...props } /></tr>;
};

type RowsProps = { rowClass?: string, rows: ComponentChild[][] }

export type BodyProps = { bodyClass?: string } & RowsProps
export const TableBody: FunctionComponent<BodyProps> = ({ bodyClass, rowClass, rows }) => {
  return <tbody class={ bodyClass ?? ''}>
    { rows.map(cells => <TableRow tag='td' cells={ cells } rowClass={ rowClass } />)}
  </tbody>;
}

export type HeaderProps = { headerClass?: string } & RowsProps
export const TableHeader: FunctionComponent<HeaderProps> = ({ headerClass, rowClass, rows }) => {
  return <thead class={ headerClass ?? ''}>
    { rows.map(cells => <TableRow tag='th' cells={ cells } rowClass={ rowClass } />)}
  </thead>;
}

export type FoooterProps = { footerClass?: string } & RowsProps
export const TableFooter: FunctionComponent<FoooterProps> = ({ footerClass, rowClass, rows }) => {
  return <tfoot class={ footerClass ?? ''}>
    { rows.map(cells => <TableRow tag='th' cells={ cells } rowClass={ rowClass } />)}
  </tfoot>;
}

const Table = {
  Body: TableBody,
  Header: TableHeader,
  Footer: TableFooter,
  Row: TableRow,
  Cells: TableCells,
}

export default Table;
